import { render, staticRenderFns } from "./UmsApplications.vue?vue&type=template&id=54d0855c&"
import script from "./UmsApplications.vue?vue&type=script&lang=js&"
export * from "./UmsApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports